import styled from "styled-components"
import { bp } from "../alquilerBuses/breakpoints"

export const HeroWrapper = styled.div`
  position: relative;
  padding-top: 80px;

  @media ${bp.m} {
    padding-top: 50px;
  }
  background-image: url(${({ img }) => img});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom center;
  display: flex;
  align-items: stretch;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0);
    pointer-events: none;
    transition: background-color 0.3s;

    @media ${bp.m} {
      background: linear-gradient(to bottom, rgba(0, 0, 0, 0.55), rgba(0, 0, 0, 0));
    }
  }

  .hero__overlay,
  .hero__info,
  .hero__formWrapper {
    position: relative;
    z-index: 1;
  }

  .hero__overlay {
    display: flex;
    align-items: flex-end;
    gap: 2rem;
  }

  .hero__info {
    width: 60%;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 2rem 0;

    h1 {
      font-size: 100px;
      font-weight: 300;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      margin: 0 0 1rem;
      line-height: 1;
      text-shadow: 0 2px 8px rgba(0, 0, 0, 0.6);

      @media ${bp.m} {
        text-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
      }

      @media ${bp.l} {
        font-size: 70px;
      }
      @media ${bp.m} {
        font-size: 50px;
      }
      @media ${bp.s} {
        font-size: 50px;
      }
      @media ${bp.xs} {
        font-size: 50px;
      }
    }

    p {
      font-size: 19px;
      font-weight: 400;
      line-height: 1.5;
      margin: 0;
      text-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);

      @media ${bp.m} {
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
      }
    }
  }

  .hero__formWrapper {
    background-color: rgba(0, 40, 86, 0.92);
    padding: 3rem 3rem 2rem;
    width: 40%;
    max-width: 500px;
    height: 100%;
    border-radius: 30px 30px 0 0;

    .cabecera {
      text-align: center;
      h3 {
        color: white;
        font-size: 35px;
        font-weight: 300;
        margin: 0 0 0.3rem;
        text-transform: uppercase;
        letter-spacing: 0.05em;

        @media ${bp.l} {
          font-size: 32px;
        }
        @media ${bp.m} {
          font-size: 30px;
        }
      }
      p {
        color: white;
        font-size: 20px;
        font-weight: 400;

        @media ${bp.l} {
          font-size: 19px;
        }
        @media ${bp.s} {
          font-size: 16px;
        }
        margin: 0 0 1rem;
      }
    }

    form {
      width: 100% !important;
      display: flex;
      flex-direction: column;
    }

    label {
      color: #FFFFFFCC;
      font-size: 18px;
      margin-bottom: 5px;
      font-weight: 400;

      @media ${bp.m} {
        font-size: 16px;
      }
    }

    input,
    textarea {
      padding: 10px 12px;
      border: 1px solid #D9D9D9;
      border-radius: 10px;
      font-size: 16px;
      outline: none;
      background-color: #D9D9D91A;
      color: white;
      transition: 0.3s;

      &:focus {
        background-color: #D9D9D966;
      }
      font-family: inherit;
      margin-bottom: 1rem;
    }

    textarea {
      resize: none;
      min-height: 70px;
    }

    .condiciones {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      margin: .2rem 0 1rem 0;

      input[type="checkbox"] {
        appearance: none;
        -webkit-appearance: none;
        width: 22px;
        height: 22px;
        min-width: 22px;
        background-color: #D9D9D9;
        border-radius: 6px;
        border: none;
        cursor: pointer;
        position: relative;
        margin: 0;
        padding: 0;

        &:checked {
          background-color: ${({ theme }) => theme.colors.amarillo};
        }

        &:checked::after {
          content: '✓';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: ${({ theme }) => theme.colors.azul};
          font-size: 14px;
          font-weight: bold;
        }
      }

      span, a {
        color: white;
        font-size: 14px;
      }
    }

    .errorForm {
      color: ${({ theme }) => theme.colors.amarillo};
      font-size: 11px;
      margin-bottom: 0.3rem;
    }

    .buttons {
      margin-top: 1rem;
      display: flex;
      justify-content: center;
      width: 100%;

      button {
        width: fit-content;
        margin: 0 auto;
      }
    }
  }

  @media ${bp.m} {
    .hero__overlay {
      flex-direction: column;
      align-items: center;
    }

    .hero__info {
      width: 100%;
      padding-bottom: 1rem;
      text-align: center;
    }

    .hero__formWrapper {
      width: 100%;
      margin: 0 auto;
    }
  }
`
